/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Start_A_Live_ChatInputs */

const en_mobile_start_a_live_chat = /** @type {(inputs: Mobile_Start_A_Live_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start a live chat`)
};

const es_mobile_start_a_live_chat = /** @type {(inputs: Mobile_Start_A_Live_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar un chat en vivo`)
};

/**
* | output |
* | --- |
* | "Start a live chat" |
*
* @param {Mobile_Start_A_Live_ChatInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_start_a_live_chat = /** @type {((inputs?: Mobile_Start_A_Live_ChatInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Start_A_Live_ChatInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_start_a_live_chat(inputs)
	return en_mobile_start_a_live_chat(inputs)
});